module.exports = __webpack_public_path__ + "static/media/Screenshot_7-thumb.ca1d51ff.png";